import React from 'react'
import { useTranslation } from 'react-i18next';
import { TcdiClassificationComponent } from '../../../../Util/TcdiClassification/TcdiClassification';

export const HeaderTCDI = ({ data }) => {
  const { t } = useTranslation();

  return (
    <header className="c-title">
      <div className="summary-header">
        <h3 className='code-text'>{data.code}</h3>
        <h2 className='title-text'>{data.nameProject}</h2>
        <h3 className='code-text'>{t('operation')}: {data.loanNumber}</h3>
      </div>

      <div className="summary-header text-align-right">
        <p>
          {t('one_pager_report.' + data.typeReport)}{' '}
          <span style={{ textTransform: 'uppercase' }}>{t('app_name')}</span>
        </p>

        <p style={{ fontSize: '0.8rem' }}>
          {t('one_pager_report.creation')}: {data.creationDate}
        </p>

        <div className='clasification-details'>
          <TcdiClassificationComponent clasification={!data.tcdValue || data.tcdValue === "0.00"  ? null : data.tcdValue} />
          <h3>{(data.tcdValue && data.tcdValue !== "0.00") ? data.tcdValue : 'N/A'} {t('tcdi_initials').toUpperCase()}</h3>
        </div>
      </div>

    </header>
  )
}
